
import { defineComponent, computed, defineExpose } from "vue";
import type { ITeachersModel } from "@/interfaces/modules/aula/ITeachersModel";

export default defineComponent({
  name: "TabEmergencyTeacher",
  props: {
    record: { type: Object as () => ITeachersModel, required: true },
    wasValidated: { type: Boolean, default: false }
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    const recordProxy = computed<ITeachersModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    const updateField = (key: keyof ITeachersModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    // Al menos un teléfono principal
    const hasAnyPrimaryPhone = computed(() =>
      !!(recordProxy.value.ContactPrimaryPhoneOption1 || recordProxy.value.ContactPrimaryPhoneOption2)
    );

    // Exponer validación opcional para el padre
    const validate = () => {
      if (!recordProxy.value.ContactPrimaryName) {
        return {
          ok: false,
          paneId: "additional-contacts-tab-pane", // ajusta al id real de tu tab
          fieldId: "primary-name",
          message: "El nombre del contacto de emergencia principal es obligatorio."
        };
      }
      if (!hasAnyPrimaryPhone.value) {
        return {
          ok: false,
          paneId: "additional-contacts-tab-pane",
          fieldId: "primary-phone1",
          message: "Debe ingresar al menos un teléfono del contacto de emergencia principal."
        };
      }
      return { ok: true };
    };

    defineExpose({ validate });

    return {
      recordProxy,
      updateField,
      hasAnyPrimaryPhone
    };
  },
});
